import { postDriverForm, putDriverForm, getDriverDetail , putDriverDetail, putDriverFile, deleteDriverFile, getDriverRequirements, getGoogleCredentials } from '../api.js'
import vendors from '../vendors.js'
import partitions from '../partitions.js'
import notifications from '../notifications.js'


function _postDriverForm(content) {
  let promise = postDriverForm(content)

  promise
    .then(() => {
      notifications.pushInfo('All validation complete, form submitted.')
    })
    .catch(error => {
      notifications.pushError(`Form submission failed! ${error.response.data.error}`, error)
    })

  return promise
}

function _putDriverForm(id, content) {
  let promise = putDriverForm(id, content)

  promise
    .then(() => {
      notifications.pushInfo('All validation complete, form submitted.')
    })
    .catch(error => {
      notifications.pushError(`Form submission failed! ${error.response.data.error}`, error)
    })

  return promise
}

function _getVendor(vendorId) {
  return vendors.getVendorFromServer()
    .then(() => {
      return vendors.getVendor(vendorId)
    })
}

function _getDriverDetail(driverId) {
  let promise = getDriverDetail(driverId)

  promise.catch(error => {
    notifications.pushError(`Unable to get driver detail. ${error.response.statusText}`, error)
  })
  return promise
}

function _putDriverDetail(driverId, data) {
  let promise = putDriverDetail(driverId, data)
  promise
    .then(() => {
      notifications.pushInfo('Action completed.')
    })
    .catch(error => {
      console.log(error)
      if (error.response?.data?.error) {
        notifications.pushError(`Action failed! ${error.response.data.error}`, error)
      } else if (error.response.status == 403){
        notifications.pushError(`Action failed! You don't have permission`)
      } else {
        notifications.pushError(`Action failed! ${error.response.statusText}`)
      }
    })

  return promise
}

function _putDriverFile(driverId, file) {
  let promise = putDriverFile(driverId, file)
  promise
    .then(() => {
      notifications.pushInfo('File uploaded.')
    })
    .catch(error => {
      notifications.pushError('File upload failed!', error)
      console.log(error)
    })
    
  return promise
}

function _deleteDriverFile(driverId, fileId) {
  let promise = deleteDriverFile(driverId, fileId)
  promise
    .then(() => {
      notifications.pushInfo('File deleted.')
    })
    .catch(error => {
      notifications.pushError('File deletion failed!', error)
      console.log(error)
    })
    
  return promise
}

function _getDriverFormVendorOptionsFromCapability(user) {
  if (user === undefined) {
    return Promise.resolve([])
  }

  let capSelectVendor = user.can('select_driver_vendor')
  let capViewDriverForm = user.getCapability('view_driver_form')
  let vendorOptions = capViewDriverForm.getVendorOptions()

  let userConfigVendorId = user.getConfig('vendor_id')

  let promiseVendor = vendors.getVendorFromServer()
  let promisePartition = partitions.getPartitionFromServer()

  let promiseFinalVendorOptions = Promise.all([promiseVendor, promisePartition])
    .then(([...allVendors],) => {
      if (capSelectVendor) {
        return allVendors[0].data.map(vendor => ({
          label: `${vendor.name} -- ${partitions.getPartitionNameSync(vendor.partition.id)}`,
          value: vendor.id,
        }))
      }
      if (vendorOptions.length === 0 && userConfigVendorId) {
        vendorOptions = [{ vendor: userConfigVendorId }]
      }
      return vendorOptions
        .filter(option => vendors.getVendorSync(option.vendor) !== undefined)
        .map(function (option) {
          let vendor = vendors.getVendorSync(option.vendor)
          return {
            label: `${vendor.name} -- ${partitions.getPartitionNameSync(vendor.partition.id)}`,
            value: option.vendor,
          }
        })
    })

  return promiseFinalVendorOptions
}

function _getDriverRequirements(vendorId) {
  let promise = getDriverRequirements(vendorId)

  promise.catch(error => {
    notifications.pushError(`Unable to get driver requirements. ${error.response.statusText}`, error)
  })
  return promise
}

function _getGoogleCredentials() {
  let promise = getGoogleCredentials()

  promise.catch(error => {
    notifications.pushError(`Error loading Google Drive: ${error.response.statusText}. Document storage is unavailable.`, error)
  })
  return promise
}

function _canSubmitNewDriver(user) {
  if (user === undefined) {
    return false
  }

  return user.can('submit_new_driver')
}

function _canUpdateDriver(user) {
    if (user === undefined) {
        return false
    }

    return user.can('edit_driver')
}


function _canViewInternalCstData(user) {
  if (user === undefined) {
    return false
  }

  return user.can('view_internal_cst_data')
}

function _canActivateDriver(user) {
  if (user === undefined) {
    return false
  }

  return user.can('activate_driver')
}

function _canValidateDriver(user) {
  if (user === undefined) {
    return false
  }

  return user.can('validate_driver')
}

function _init() {
  // do nothing
}

_init()

export default {
  postDriverForm: _postDriverForm,
  putDriverForm: _putDriverForm,
  getVendor: _getVendor,
  getDriverDetail: _getDriverDetail,
  putDriverDetail: _putDriverDetail,
  putDriverFile: _putDriverFile,
  deleteDriverFile: _deleteDriverFile,
  getDriverRequirements: _getDriverRequirements,
  getGoogleCredentials: _getGoogleCredentials,
  canSubmitNewDriver: _canSubmitNewDriver,
  canUpdateDriver: _canUpdateDriver,
  canActivateDriver: _canActivateDriver,
  canValidateDriver: _canValidateDriver,
  canViewInternalCstData: _canViewInternalCstData,
  getDriverFormVendorOptionsFromCapability: _getDriverFormVendorOptionsFromCapability,
}